import { Box, Button, Tab, Tabs } from "@mui/material";
import { PlusIcon } from "app/icons";
import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

import {
  CUSTOMER_DETAIL_TAB_LABELS,
  CUSTOMER_DETAIL_TABS,
  CustomerDetailTab,
  CustomerPriceQuote,
} from "../../../types";
import PriceQuotesTable from "../PriceQuotesTable";
import { useStyles } from "./styles";

type Props = {
  priceQuotes: CustomerPriceQuote[];
};

const CustomerDetailTabs = ({ priceQuotes }: Props) => {
  const { t, i18n } = useTranslation();
  const styles = useStyles();
  const [activeTab, setActiveTab] = useState(CustomerDetailTab.PRICE_QUOTE);
  const isHebrew = (i18n.language || "hw").startsWith("hw");

  const tabsToRender = useMemo(
    () => (isHebrew ? [...CUSTOMER_DETAIL_TABS].reverse() : CUSTOMER_DETAIL_TABS),
    [isHebrew]
  );

  return (
    <Box className={styles.root}>
      <Box className={styles.tabBarRow}>
        <Button
          variant="contained"
          className={styles.actionButton}
          startIcon={<PlusIcon />}
        >
          {t("CUSTOMERS.DETAILS.ACTIONS.ADD_PRICE_QUOTE")}
        </Button>

        <Box className={styles.tabsWrapper}>
          <Tabs
            className={styles.tabs}
            value={activeTab}
            onChange={(_, nextValue) =>
              setActiveTab(nextValue as CustomerDetailTab)
            }
            variant="scrollable"
            scrollButtons={false}
          >
            {tabsToRender.map((tab) => (
              <Tab
                key={tab}
                label={t(CUSTOMER_DETAIL_TAB_LABELS[tab])}
                value={tab}
              />
            ))}
          </Tabs>
        </Box>
      </Box>

      <PriceQuotesTable rows={priceQuotes} />
    </Box>
  );
};

export default CustomerDetailTabs;
